export default class leito{
    _id;
    _ativo;
    _codigoLeito;
    _descricao;
    _quarto;

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    
    get ativo() {
        return this._ativo;
    }
    set ativo(value) {
        this._ativo = value;
    }
    
    get codigoLeito() {
        return this._codigoLeito;
    }
    set codigoLeito(value) {
        this._codigoLeito = value;
    }
    
    get descricao() {
        return this._descricao;
    }
    set descricao(value) {
        this._descricao = value;
    }

    get quarto() {
        return this._quarto;
    }
    set quarto(value) {
        this._quarto = value;
    }
    
    constructor(pId,pCodigoLeito,pDescricao,pAtivo,pQuarto){
        this.id = pId;
        this.codigoLeito = pCodigoLeito;
        this.descricao = pDescricao;
        this.ativo = pAtivo;
        this.quarto = pQuarto;
    }
}